import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
// routes
import { RouterLink } from 'src/routes/components';
import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, variant, ...other }, ref) => {
  const theme = useTheme();
  const { authenticated } = useAuthContext();

  // const PRIMARY_LIGHT = theme.palette.primary.light;

  // const PRIMARY_MAIN = theme.palette.primary.main;

  // const PRIMARY_DARK = theme.palette.primary.dark;

  // OR using local (public folder)
  // -------------------------------------------------------
  // const logo = (
  //   <Box
  //     component="img"
  //     src="/logo/logo_single.svg" => your path
  //     sx={{ width: 40, height: 40, cursor: 'pointer', ...sx }}
  //   />
  // );
  
  // 各variantの設定
  let variantConfig = {
    styles: { width: 205, height: 45 },
    fillColor: theme.palette.primary.main // デフォルト（PRIMARY.main）
  };
  
  if (variant === 'headerSimple') {
    variantConfig = {
      styles: { width: { xs: 80.5, md: 161 }, height: { xs: 16.5, md: 33 } },
      fillColor: theme.palette.primary.main // シンプルヘッダー用（PRIMARY.main）
    };
  } else if (variant === 'navMini') {
    variantConfig = {
      styles: { width: 40.25, height: 8.25 },
      fillColor: theme.palette.primary.main // ミニナビ用（PRIMARY.main）
    };
  } else if (variant === 'authClassic') {
    variantConfig = {
      styles: { width: 267, height: 45 },
      fillColor: '#fff' // ログイン画面用（白色）
    };
  }

  const logo = (
    <Box
      ref={ref}
      component="div"
      sx={{
        display: 'inline-flex',
        ...variantConfig.styles,
        ...sx,
      }}
      {...other}
    >
      <svg width="267" height="45" viewBox="0 0 267 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_773_408)">
          <path d="M94.1588 15.7301C91.8475 13.6394 89.8377 13.5399 89.0338 13.5399C88.2299 13.5399 86.8231 13.6394 86.0191 14.635C85.5167 15.1328 85.2152 15.7301 85.2152 16.5266C85.2152 17.323 85.4162 17.8208 85.9186 18.2191C86.6221 18.916 87.7275 19.2146 89.7372 19.9115L92.0485 20.8076C93.3549 21.3053 95.0632 22.0022 96.269 23.0974C98.0779 24.7899 98.4798 26.9801 98.4798 28.7722C98.4798 31.958 97.3744 34.6461 95.7666 36.3385C93.0534 39.1261 89.1343 39.4248 87.024 39.4248C84.9138 39.4248 82.904 39.1261 80.9947 38.1306C79.3868 37.3341 77.6785 35.9403 76.4727 34.8452L80.1908 29.8673C80.9947 30.6637 82.2005 31.6593 83.0045 32.1571C84.2103 32.854 85.4162 33.2522 86.8231 33.2522C88.2299 33.2522 89.0338 33.0531 90.0387 32.1571C90.6416 31.6593 91.1441 30.8629 91.1441 29.6682C91.1441 28.4735 90.7421 28.0753 90.0387 27.4779C89.2348 26.781 87.3255 26.0841 86.4211 25.7854L83.9089 24.8894C82.502 24.3916 80.7937 23.7943 79.5878 22.5C77.98 20.8076 77.779 18.7168 77.779 17.2235C77.779 14.5354 78.5829 12.2456 80.4922 10.354C82.703 8.16375 85.2152 7.56641 88.1294 7.56641C91.0436 7.56641 93.6563 7.96464 97.2739 10.5531L94.0583 15.6306L94.1588 15.7301Z" fill={variantConfig.fillColor}/>
          <path d="M114.86 8.26318L105.816 38.6282H98.9824L108.026 8.26318H114.86Z" fill={variantConfig.fillColor}/>
          <path d="M127.32 8.26318C131.34 8.26318 135.661 8.86053 139.379 12.4446C142.092 15.0331 143.8 18.6172 143.8 23.2964C143.8 27.9756 142.193 31.5596 139.58 34.0486C135.359 38.3296 130.033 38.6282 127.521 38.6282H117.573V8.26318H127.32ZM124.707 32.7543H126.617C128.124 32.7543 131.34 32.6548 133.651 30.6636C135.259 29.2698 136.666 26.6813 136.666 23.2964C136.666 19.9114 135.359 17.9203 134.153 16.7256C131.842 14.4357 128.828 14.1371 126.717 14.1371H124.808V32.6548L124.707 32.7543Z" fill={variantConfig.fillColor}/>
          <path d="M164.2 14.2366H153.95V20.1105H163.697V26.084H153.95V32.8539H164.2V38.8273H146.815V8.26318H164.2V14.2366Z" fill={variantConfig.fillColor}/>
          <path d="M178.369 8.26318C181.082 8.26318 183.996 8.66141 186.408 10.7521C189.021 13.0419 189.423 16.0287 189.423 18.1194C189.423 21.9026 187.915 24.0928 186.81 25.2875C184.398 27.7765 181.183 27.9756 178.972 27.9756H174.651V38.6282H167.516V8.26318H178.369ZM174.651 22.3008H177.163C178.168 22.3008 179.876 22.3008 180.982 21.2057C181.585 20.6083 182.087 19.5132 182.087 18.2189C182.087 16.9247 181.585 15.9291 180.982 15.2322C179.876 14.2366 178.369 14.1371 177.063 14.1371H174.651V22.4004V22.3008Z" fill={variantConfig.fillColor}/>
          <path d="M220.072 12.0464C222.986 14.8341 224.896 18.8164 224.896 23.4956C224.896 28.1748 223.388 31.6593 220.072 34.8451C217.258 37.5332 213.339 39.3252 208.214 39.3252C203.089 39.3252 198.567 37.0354 196.256 34.8451C193.342 32.1571 191.433 27.9756 191.433 23.4956C191.433 19.0155 193.442 14.7345 196.156 11.9469C198.266 9.85618 202.084 7.4668 208.114 7.4668C214.143 7.4668 216.856 8.96016 219.972 11.8473L220.072 12.0464ZM201.381 16.7256C200.075 18.0199 198.668 20.2102 198.668 23.5951C198.668 26.9801 199.572 28.573 201.482 30.4646C203.491 32.3562 205.702 32.9535 208.013 32.9535C210.325 32.9535 213.339 31.8584 214.847 30.365C216.052 29.2699 217.56 27.0796 217.56 23.5951C217.56 20.1106 216.253 18.1195 214.847 16.7256C213.339 15.2323 210.928 14.1372 208.114 14.1372C205.3 14.1372 203.089 15.1327 201.381 16.7256Z" fill={variantConfig.fillColor}/>
          <path d="M242.983 15.7301C240.672 13.6394 238.662 13.5399 237.859 13.5399C237.055 13.5399 235.648 13.6394 234.844 14.635C234.341 15.1328 234.04 15.7301 234.04 16.5266C234.04 17.323 234.241 17.8208 234.743 18.2191C235.447 18.916 236.552 19.2146 238.562 19.9115L240.873 20.8076C242.18 21.3053 243.888 22.0022 245.094 23.0974C246.903 24.7899 247.305 26.9801 247.305 28.7722C247.305 31.958 246.199 34.6461 244.591 36.3385C241.878 39.1261 237.959 39.4248 235.849 39.4248C233.738 39.4248 231.729 39.1261 229.819 38.1306C228.212 37.3341 226.503 35.9403 225.297 34.8452L229.015 29.8673C229.819 30.6637 231.025 31.6593 231.829 32.1571C233.035 32.854 234.241 33.2522 235.648 33.2522C237.055 33.2522 237.859 33.0531 238.863 32.1571C239.466 31.6593 239.969 30.8629 239.969 29.6682C239.969 28.4735 239.567 28.0753 238.863 27.4779C238.06 26.781 236.15 26.0841 235.246 25.7854L232.734 24.8894C231.327 24.3916 229.618 23.7943 228.413 22.5C226.805 20.8076 226.604 18.7168 226.604 17.2235C226.604 14.5354 227.408 12.2456 229.317 10.354C231.528 8.16375 234.04 7.56641 236.954 7.56641C239.868 7.56641 242.481 7.96464 246.099 10.5531L242.883 15.6306L242.983 15.7301Z" fill={variantConfig.fillColor}/>
          <path d="M260.468 14.2366V38.7278H253.334V14.2366H247.405L251.123 8.26318H267V14.2366H260.368H260.468Z" fill={variantConfig.fillColor}/>
          <path d="M21.9067 44.9999H39.5929C39.9948 44.9999 40.2963 44.5021 39.8943 44.2035L22.2082 26.6813C21.9067 26.3827 21.4043 26.6813 21.4043 26.98V44.5021C21.4043 44.8008 21.6053 44.9999 21.9067 44.9999Z" fill={variantConfig.fillColor}/>
          <path d="M42.2057 23.8938H24.5196C24.1176 23.8938 23.8162 24.3916 24.2181 24.6903L41.9042 42.2124C42.2057 42.5111 42.7082 42.2124 42.7082 41.9137V24.3916C42.7082 24.0929 42.5072 23.8938 42.2057 23.8938Z" fill={variantConfig.fillColor}/>
          <path d="M21.9068 21.1061H39.593C39.9949 21.1061 40.2964 20.6083 39.8944 20.3097L22.3088 2.78753C22.0073 2.48886 21.5049 2.78753 21.5049 3.08621V20.6083C21.5049 20.907 21.7059 21.1061 22.0073 21.1061H21.9068Z" fill={variantConfig.fillColor}/>
          <path d="M42.2057 0H24.5196C24.1176 0 23.8162 0.497788 24.2181 0.79646L41.9042 18.3186C42.2057 18.6173 42.7082 18.3186 42.7082 18.0199V0.497788C42.7082 0.199115 42.5072 0 42.2057 0Z" fill={variantConfig.fillColor}/>
          <path d="M45.522 3.08621V20.6083C45.522 20.907 45.723 21.1061 46.0244 21.1061H63.7105C64.1125 21.1061 64.414 20.6083 64.012 20.3097L46.3259 2.78753C46.0244 2.48886 45.522 2.78753 45.522 3.08621Z" fill={variantConfig.fillColor}/>
          <path d="M18.5906 41.8141V24.292C18.5906 23.9933 18.3896 23.7942 18.0881 23.7942H0.502511C0.100554 23.7942 -0.200914 24.292 0.201044 24.5907L17.8872 42.1128C18.1886 42.4114 18.6911 42.1128 18.6911 41.8141H18.5906Z" fill={variantConfig.fillColor}/>
        </g>
        <defs>
          <clipPath id="clip0_773_408">
            <rect width="267" height="45" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link component={RouterLink} href={authenticated ? "/" : "https://sidepost.app/"} target={authenticated ? "_self" : "_blank"} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
  variant: PropTypes.string, 
};

export default Logo;
